import React, { useState } from 'react'
import './InsuranceSpotlight.css'
import TabContext from '@mui/lab/TabContext'
import { Box, Tab } from '@material-ui/core'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import {
  INSURANCE_SPOTLIGHT_DATA,
  SPOTLIGHT_TAB_TYPES,
  SPOTLIGHT_TABS,
} from 'src/utils/constants/InsuranceSpotlightData'
import { Grid, Modal } from '@mui/material'
import Scenarios from 'src/components/ceo/InsuranceSpotlight/Scenarios'
import { getThumbNail } from 'src/utils/commonMethods'
import PlayButton from 'src/assets/InsuranceSpotlightImages/Common/Play_Button.svg'
import VideoPlayer from 'src/components/common/VideoPlayer'
import WakeUpCall from 'src/assets/InsuranceSpotlightImages/Common/WakeUpCall.svg'

const InsuranceSpotlight = () => {
  const [tabValue, setTabValue] = useState(SPOTLIGHT_TAB_TYPES.FIRE)
  const [videoPlayerDetails, setVideoPlayerDetails] = useState({
    isOpen: false,
    data: null,
  })

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const isDataPresent = () => {
    return !!INSURANCE_SPOTLIGHT_DATA[tabValue]?.data
  }

  const getScenarioData = () => {
    return INSURANCE_SPOTLIGHT_DATA[tabValue]?.data
  }

  const getLinksData = () => {
    let linksData = [
      ...INSURANCE_SPOTLIGHT_DATA[tabValue]?.youtubeLinks,
      ...INSURANCE_SPOTLIGHT_DATA[SPOTLIGHT_TAB_TYPES?.ALL]?.youtubeLinks,
      ...INSURANCE_SPOTLIGHT_DATA[SPOTLIGHT_TAB_TYPES?.GENERAL]?.youtubeLinks,
      ...INSURANCE_SPOTLIGHT_DATA[SPOTLIGHT_TAB_TYPES?.CLAIMS]?.youtubeLinks,
    ]
    linksData = linksData?.reduce((accumulator, current) => {
      if (!accumulator?.find((item) => item?.link === current?.link)) {
        accumulator.push(current)
      }
      return accumulator
    }, [])

    return linksData
  }

  const closeVideoPlayer = () => {
    setVideoPlayerDetails({
      isOpen: false,
      data: null,
    })
  }

  const openVideoPlayer = (data) => {
    setVideoPlayerDetails({
      isOpen: true,
      data,
    })
  }
  return (
    <>
      {videoPlayerDetails?.isOpen ? (
        <Modal
          id='modal'
          open={videoPlayerDetails?.isOpen}
          onClose={closeVideoPlayer}
        >
          <div className={'video-modal-container'}>
            <VideoPlayer
              data={videoPlayerDetails?.data}
              closeVideoPlayer={closeVideoPlayer}
            />
          </div>
        </Modal>
      ) : null}
      <div>{/* main banner*/}</div>
      <div className='tab-container'>
        {/* Tab Container*/}

        <TabContext value={tabValue}>
          <Box className='tab-context-container'>
            <Box className='tab-images-container'>
              <Box className='wakeUpBox'>
                <Box>
                  <img
                    src={WakeUpCall}
                    alt='WakeUpCall'
                    className='w-100'
                  ></img>
                </Box>
              </Box>
            </Box>
            <Box>
              <TabList
                id='tabList'
                onChange={handleTabChange}
                className='tab-list-container'
                variant='scrollable'
              >
                {SPOTLIGHT_TABS?.map((tabListItem) => {
                  return (
                    <Tab
                      key={`tab_${tabListItem?.type}`}
                      label={tabListItem?.label}
                      value={tabListItem?.type}
                      wrapped
                      className={`spotlight-tab ${
                        tabValue === tabListItem?.type
                          ? 'spotlight-tab-selected'
                          : null
                      }`}
                    />
                  )
                })}
              </TabList>
            </Box>
          </Box>

          {SPOTLIGHT_TABS?.map((tabListItem) => (
            <TabPanel
              key={`tabPanel_${tabListItem?.type}`}
              value={tabListItem?.type}
              className='spotlight-tab-panel'
            >
              {isDataPresent() && (
                <div className='scenario-container'>
                  <Scenarios scenarioData={getScenarioData()} />
                </div>
              )}

              <div className='links-container'>
                {isDataPresent() && (
                  <div className='others-heading'>Others</div>
                )}
                <Grid container spacing={2} alignItems={'stretch'}>
                  {getLinksData()?.map((linkDataItem) => {
                    return (
                      <Grid
                        key={linkDataItem}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        xl={3}
                      >
                        <div
                          className='youtube-link-container'
                          id='youtubeLinkContainer'
                          onClick={() => {
                            openVideoPlayer(linkDataItem)
                          }}
                        >
                          <div>
                            <img
                              className='youtube-video-thumbnail'
                              src={getThumbNail(linkDataItem?.imageLink)}
                              alt='Thumbnail'
                            />
                            <div className='youtube-video-title'>
                              {linkDataItem?.title}
                            </div>
                            <div className='youtube-video-type'>
                              {linkDataItem?.type}
                            </div>
                          </div>
                          <img
                            className='youtube-play-button'
                            src={PlayButton}
                            alt='Play'
                          />
                        </div>
                      </Grid>
                    )
                  })}
                </Grid>
              </div>
            </TabPanel>
          ))}
        </TabContext>
      </div>
    </>
  )
}
export default InsuranceSpotlight
